import React, { useEffect, useState } from "react";
import { Crown, Check, Rocket, Orbit } from "lucide-react";
import { api } from "@/lib/api";
import { useI18n } from "@/context/I18nContext";

const TIER_ICONS = {
  free: Orbit,
  intermediate: Rocket,
  vip: Crown,
};

export default function Subscription() {
  const { t } = useI18n();
  const [tiers, setTiers] = useState([]);
  const [currentTier, setCurrentTier] = useState("free");

  useEffect(() => {
    api.get("/subscription/tiers").then((r) => {
      setTiers(r.data.tiers);
      setCurrentTier(r.data.current_tier);
    });
  }, []);

  return (
    <div className="space-y-6">
      <div>
        <div className="text-xs tracking-[0.3em] uppercase text-[#6E7587]">{t("sub.eyebrow")}</div>
        <h1 className="font-display text-3xl font-bold mt-1">{t("sub.title")}</h1>
        <p className="text-sm text-[#A3A9B8] mt-2 max-w-2xl">
          {t("sub.subtitle")}
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-[#2A2E38]">
        {tiers.map((tier) => {
          const Icon = TIER_ICONS[tier.key] || Orbit;
          const active = currentTier === tier.key;
          return (
            <div
              key={tier.key}
              data-testid={`subscription-tier-${tier.key}`}
              className={`bg-[#141720] p-6 relative ${
                active ? "ring-1 ring-[#7C5CFF]" : ""
              }`}
            >
              {active && (
                <span className="absolute top-4 right-4 text-[10px] tracking-[0.2em] uppercase px-2 py-1 bg-[#7C5CFF]/15 text-[#7C5CFF] border border-[#7C5CFF]/40 rounded-sm">
                  {t("sub.active")}
                </span>
              )}
              <Icon
                size={22}
                className={tier.key === "vip" ? "text-[#D19B54]" : tier.key === "intermediate" ? "text-[#9C82FF]" : "text-[#7C5CFF]"}
              />
              <h3 className="font-display text-2xl font-bold mt-4">{tier.name}</h3>
              <div className="mt-3 flex items-end gap-2">
                <span className="font-mono text-3xl">
                  {tier.price_usd === 0 ? t("sub.free_price") : `$${tier.price_usd.toFixed(2)}`}
                </span>
                {tier.price_usd > 0 && (
                  <span className="text-xs text-[#6E7587] mb-1.5">{t("sub.lifetime")}</span>
                )}
              </div>
              <ul className="mt-5 space-y-2 text-sm">
                {tier.perks.map((p) => (
                  <li key={p} className="flex items-start gap-2 text-[#A3A9B8]">
                    <Check size={14} className="mt-0.5 text-[#7C9C69] shrink-0" />
                    <span>{p}</span>
                  </li>
                ))}
              </ul>

              <div className="mt-5 pt-5 border-t border-[#2A2E38] text-xs text-[#6E7587] font-mono space-y-1">
                <div>{t("sub.apr_bonus")} <span className="text-[#F4F1EB]">+{(tier.apr_bonus * 100).toFixed(2)}%</span></div>
                <div>{t("sub.deposit_limit")} ×{tier.limit_multiplier.toFixed(1)}</div>
              </div>
            </div>
          );
        })}
      </div>

      <div className="border border-[#2A2E38] bg-[#141720] p-6">
        <div className="text-[10px] tracking-[0.3em] uppercase text-[#6E7587]">{t("sub.contact_eyebrow")}</div>
        <h3 className="font-display text-lg font-bold mt-1">{t("sub.contact_title")}</h3>
        <p className="text-sm text-[#A3A9B8] mt-2">
          {t("sub.contact_body")}
        </p>
      </div>
    </div>
  );
}
